import ContactForm from "../../../MicrospecDynamicUI/Pages/SectionsMapper/Contact/ContactForm";
const MicrospecFlowCommonContactForm = () => {
    return (
        <ContactForm spec={{
            id: "contact",
            fields: [
                {
                    key: "full_name",
                    label: {
                        localizationObject: {
                            type: "Internal",
                            text: "fullName",
                        }
                    }, type: "text", required: true
                },
                {
                    key: "email",
                    label: {
                        localizationObject: {
                            type: "Internal",
                            text: "email",
                        }
                    }, type: "text", required: true
                },
                {
                    key: "phone",
                    label: {
                        localizationObject: {
                            type: "Internal",
                            text: "phone",
                        }
                    }, type: "text", required: false
                },
                {
                    key: "message",
                    label: {
                        localizationObject: {
                            type: "Internal",
                            text: "message",
                        }
                    }, type: "text", required: true
                },
            ]
        }} />
    )
}

export default MicrospecFlowCommonContactForm;